import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Search, ArrowLeft, Newspaper } from 'lucide-react';
import YegoLogo from './YegoLogo';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 flex items-center justify-center px-4">
      <div className="max-w-lg w-full text-center">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <YegoLogo size={80} />
        </div>
        
        {/* 404 Text */}
        <h1 className="text-8xl font-bold text-emerald-500 mb-4">404</h1>
        
        {/* Message */}
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
          Page Not Found
        </h2>
        <p className="text-gray-600 dark:text-gray-400 mb-8">
          Oops! The page you&apos;re looking for doesn&apos;t exist or has been moved.
          Let&apos;s get you back on track.
        </p>
        
        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-emerald-500 hover:bg-emerald-600 text-white font-semibold rounded-lg transition-colors"
          >
            <Home className="h-5 w-5" />
            Go Home
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-gray-200 dark:bg-gray-800 hover:bg-gray-300 dark:hover:bg-gray-700 text-gray-900 dark:text-white font-semibold rounded-lg transition-colors"
          >
            <ArrowLeft className="h-5 w-5" />
            Go Back
          </button>
        </div>
        
        {/* Suggestions */}
        <div className="mt-12 pt-8 border-t border-gray-200 dark:border-gray-800">
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
            Here are some helpful links:
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/"
              className="text-emerald-600 dark:text-emerald-400 hover:underline text-sm flex items-center gap-1"
            >
              <Newspaper className="h-4 w-4" />
              Latest News
            </Link>
            <Link
              to="/?category=local"
              className="text-emerald-600 dark:text-emerald-400 hover:underline text-sm flex items-center gap-1"
            >
              <Search className="h-4 w-4" />
              Local News
            </Link>
            <Link
              to="/?category=videos"
              className="text-emerald-600 dark:text-emerald-400 hover:underline text-sm flex items-center gap-1"
            >
              <Search className="h-4 w-4" />
              Videos
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
